import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ClientItem } from 'src/app/model/client-item';
import { CoverageItem } from 'src/app/model/coverage-item';
import { CommonService } from 'src/app/services/common.service';
import { MSSPService } from 'src/app/services/mssp.service';
import { DeviceHistoryComponent } from '../device-history/device-history.component';
import { RequestIntegrationItem } from 'src/app/model/client-policy-detail';

@Component({
  selector: 'app-device-view',
  templateUrl: './device-view.component.html',
  styleUrls: ['./device-view.component.scss']
})
export class DeviceViewComponent implements OnInit {
  @ViewChild(DeviceHistoryComponent)
  public deviceHistory!: DeviceHistoryComponent;

  @Input() device!:RequestIntegrationItem;
  @Input() msspItem!:CoverageItem;
  @Input() singleDevice: boolean = false;
  @Input() claimHistory!:any[];

  constructor(
    private commonService:CommonService,
  ) { }

  ngOnInit(): void {
  }

  addYears(initDate:string, one:boolean){
    var dateParts:any = initDate.split('/') 
    var newDate = new Date(+dateParts[2],dateParts[1]-1, dateParts[0])
    var dateProduct = new Date(+dateParts[2],dateParts[1]-1, dateParts[0])
    this.commonService.productDate = dateProduct
    if (one) {
      newDate.setFullYear(newDate.getFullYear()+1)
      this.commonService.startDate = newDate
      return newDate
    }
    newDate.setFullYear(newDate.getFullYear()+2)
    this.commonService.endDate = newDate
    return newDate
  }

  searchClaim(){
    this.deviceHistory.toggle()
  }
}